import { render, staticRenderFns } from "./PsPatientMedication.vue?vue&type=template&id=1cddba56&scoped=true&"
import script from "./PsPatientMedication.vue?vue&type=script&lang=js&"
export * from "./PsPatientMedication.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientMedication.vue?vue&type=style&index=0&id=1cddba56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cddba56",
  null
  
)

export default component.exports